module.exports = __webpack_public_path__ + "assets/terms/termos-bioritmo.35d93c61.pdf";